import React from 'react';
import { Grid2 as Grid } from '@mui/material';
import { TextField, Button } from '../common';
import { BaseDialog, BaseDialogProps, BaseDialogState } from '../common/dialog/BaseDialog';

interface Props extends BaseDialogProps {
    readonly onSend: (title: string, body: string) => void;
}

interface State extends BaseDialogState {
    readonly title: string;
    readonly body: string;
}

export class PlayerSendPushNotificationDialog extends BaseDialog<Props, State> {
    state = this.initState();

    protected renderContent(): React.JSX.Element {
        const { title, body } = this.state;

        return (
            <Grid container={true} spacing={0}>
                <Grid size={12}>
                    <TextField
                        label="Title"
                        fullWidth={true}
                        variant="outlined"
                        multiline={true}
                        value={title}
                        onChange={this.onTitleChange}
                    />
                </Grid>
                <Grid size={12}>
                    <TextField
                        label="Body"
                        fullWidth={true}
                        variant="outlined"
                        multiline={true}
                        value={body}
                        onChange={this.onBodyChange}
                    />
                </Grid>
            </Grid>
        );
    }

    protected renderActions(): React.JSX.Element {
        return (
            <Button text="Send" variant="contained" onClick={this.onSend}/>
        );
    }

    protected initState(): State {
        return {
            title: '',
            body: '',
        };
    }

    private onTitleChange = (title: string) => this.setState({ title });

    private onBodyChange = (body: string) => this.setState({ body });

    private onSend = () => {
        const { title, body } = this.state;
        this.props.onSend(title, body);
        this.onClose();
    }
}
